import { useNavigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import { logout as logoutAPI } from "../../services/authService";
import { useToast } from "../../contexts/ToastContext";

const useHeaderLogic = () => {
  const { showSuccessToast, showErrorToast } = useToast();

  const {
    user,
    isAuthenticated,
    logout,
    showAdminPanel,
    setIsAdminPanelState,
  } = useAuth();
  const navigate = useNavigate();

  const isAdmin = user?.is_admin || false;

  const onLogout = async () => {
    try {
      const res = await logoutAPI();
      logout();
      showSuccessToast(res.data.message);
      navigate("/login");
    } catch (err: any) {
      const msg = err.response?.data?.message || "Something went wrong.";
      showErrorToast(msg);
    }
  };

  return {
    user,
    isAuthenticated,
    isAdmin,
    onLogout,
    showAdminPanel,
    setIsAdminPanelState,
  };
};

export default useHeaderLogic;
